<template>
  <div class="layout-main">
    <div class="mod-hero" style="margin-top: -100px">
      <div class="cdc-carousel__item">
        <div class="cdc-carousel__item-inner">
          <div
            class="cdc-carousel__item-bg"
            style="
              /* background-image: url(https://qcloudimg.tencent-cloud.cn/raw/e21243f005aed04a2484c0d20659ae42.png); */
              background-color: #f1f5fa;
            "
          ></div>
          <div class="cdc-carousel__item-content">
            <div class="cdc-carousel__item-title">全部课程</div>
            <div class="cdc-carousel__item-desc">跨境电商学习平台</div>
            <div class="cdc-carousel__item-operate">
              <div class="cdc-carousel__item-search">
                <input
                  class="search-input"
                  v-model="listQuery.keywords"
                  placeholder="搜索课程"
                  @keyup.13="queryCourse"
                />
                <button class="cdc-btn search-btn" @click="queryCourse">
                  搜索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mod-selector">
      <div class="mod-selector__inner">
        <div class="mod-selector__item">
          <div class="mod-selector__item-inner">
            <div class="mod-selector__item-label">平台：</div>
            <div class="mod-selector__item-tags">
              <div
                class="mod-selector__item-tag"
                :class="{ 'is-selected': listQuery.platform === '' }"
                @click="queryPlatform('')"
              >
                全部
              </div>
              <div
                class="mod-selector__item-tag"
                :class="{ 'is-selected': listQuery.platform === item.value }"
                v-for="item in platformOptions"
                @click="queryPlatform(`${item.value}`)"
                :key="item.value"
              >
                {{ item.text }}
              </div>
              <!-- <div class="mod-selector__item-tag is-selected">全部</div>
              <div class="mod-selector__item-tag">速卖通</div>
              <div class="mod-selector__item-tag">亚马逊</div>
              <div class="mod-selector__item-tag">eBay</div>
              <div class="mod-selector__item-tag">选品</div>
              <div class="mod-selector__item-tag">谷歌</div>
              <div class="mod-selector__item-tag">Facebook</div>
              <div class="mod-selector__item-tag">TikTok</div> -->
            </div>
          </div>
        </div>
        <div class="mod-selector__item">
          <div class="mod-selector__item-inner">
            <div class="mod-selector__item-label">类型：</div>
            <div class="mod-selector__item-tags">
              <!-- <div class="mod-selector__item-tag">全部</div>
              <div class="mod-selector__item-tag is-selected">实习指导书</div>
              <div class="mod-selector__item-tag">操作视频</div>
              <div class="mod-selector__item-tag">教学课件</div>
              <div class="mod-selector__item-tag">学习视频</div> -->
              <div
                class="mod-selector__item-tag"
                :class="{ 'is-selected': listQuery.type === '' }"
                @click="queryType('')"
              >
                全部
              </div>
              <div
                class="mod-selector__item-tag"
                :class="{ 'is-selected': listQuery.type === item.value }"
                v-for="item in typeOptions"
                @click="queryType(`${item.value}`)"
                :key="item.value"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="mod-selector__item">
          <div class="mod-selector__item-inner">
            <div class="mod-selector__item-label">层次：</div>
            <div class="mod-selector__item-tags">
              <!-- <div class="mod-selector__item-tag is-selected">全部</div>
              <div class="mod-selector__item-tag">零基础</div>
              <div class="mod-selector__item-tag">初阶</div>
              <div class="mod-selector__item-tag">进阶</div>
              <div class="mod-selector__item-tag">高阶</div> -->
              <div
                class="mod-selector__item-tag"
                :class="{ 'is-selected': listQuery.level === '' }"
                @click="queryLevel('')"
              >
                全部
              </div>
              <div
                class="mod-selector__item-tag"
                :class="{ 'is-selected': listQuery.level === item.value }"
                v-for="item in levelOptions"
                @click="queryLevel(`${item.value}`)"
                :key="item.value"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cdc-tech-video__main">
      <div class="mod-filter">
        <ul class="mod-filter__list">
          <li class="mod-filter__item is-selected">人气</li>
          <li class="mod-filter__item">最新发布</li>
        </ul>
        <div class="mod-filter__total">共找{{ total }}个课程</div>
      </div>

      <div class="mod-course">
        <div class="mod-course__list">
          <div class="item" v-for="item in listData" :key="item.id">
            <!-- <a :href="`/course/${item.id}`" target="_blank"></a> -->
            <router-link :to="`/course/${item.id}`">
              <div class="section">
                <div
                  alt="课程封面"
                  class="img"
                  :style="{
                    height: '162px',
                    'background-image': `url(${fileUrl}/${item.mainImage})`,
                    'background-size': 'cover',
                    'background-color': '#efefef',
                  }"
                ></div>
                <div class="con">
                  <div class="info">
                    <h3 class="title">{{ item.title }}</h3>
                    <p>
                      {{
                        $store.getters["enums/getSysEnumTextByValue"](
                          "CourseLevel",
                          item.level
                        )
                      }}
                      /
                      {{
                        $store.getters["enums/getSysEnumTextByValue"](
                          "CourseType",
                          item.type
                        )
                      }}
                    </p>
                    <span>200人报名</span>
                  </div>
                  <div class="bottom">
                    <div class="price_con">
                      <span class="free">实训内置</span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { courseService } from "@/api/courses";
export default {
  name: "List",
  components: {},
  data() {
    return {
      tableKey: 0,
      tableSize: "",
      listData: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: undefined,
        platform: "",
        type: "",
        level: "",
      },
      platformOptions: [],
      typeOptions: [],
      levelOptions: [],

      fileUrl: process.env.VUE_APP_FILE_URL,
    };
  },
  created() {
    this.getList();

    this.loadCompanysOptions();
    this.loadTypeOptions();
    this.loadLevelOptions();
  },
  methods: {
    loadCompanysOptions() {
      this.platformOptions =
        this.$store.getters["enums/getSysEnums"]("Platform");
    },
    loadTypeOptions() {
      this.typeOptions = this.$store.getters["enums/getSysEnums"]("CourseType");
    },
    loadLevelOptions() {
      this.levelOptions =
        this.$store.getters["enums/getSysEnums"]("CourseLevel");
    },
    getList() {
      this.listLoading = true;

      courseService
        .getCoursePageListStudent({
          title: this.listQuery.keywords,
          platform: this.listQuery.platform,
          type: this.listQuery.type,
          level: this.listQuery.level,
          skipCount: (this.listQuery.page - 1) * this.listQuery.limit,
          maxResultCount: this.listQuery.limit,
          // sorting: this.listQuery.sort
        })
        .then((res) => {
          this.listData = res.items;
          this.total = res.totalCount;

          this.listLoading = false;
        });
    },
    // 搜索课程
    queryCourse() {
      this.getList();
    },
    // 搜索平台
    queryPlatform(value) {
      this.listQuery.platform = value;
      this.getList();
    },
    // 搜索类型
    queryType(value) {
      this.listQuery.type = value;
      this.getList();
    },
    // 搜索层次
    queryLevel(value) {
      this.listQuery.level = value;
      this.getList();
    },
  },
};
</script>

<style scoped>
.layout-main {
  margin: 0;
  padding: 0;
}

.layout-main .mod-hero {
  height: 320px;
}

.layout-main .mod-hero .cdc-carousel__item {
  width: 100%;
  height: 100%;
}

.cdc-carousel__item-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.cdc-carousel__item-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-position: top;
  background-size: auto 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}

.cdc-carousel__item-content {
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 152px 10px 10px;
  position: relative;
}

.cdc-carousel__item-desc,
.cdc-carousel__item-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.cdc-carousel__item-title {
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  max-width: 480px;
  margin-bottom: 16px;
  color: #181818;
}

.cdc-carousel__item-desc {
  font-size: 16px;
  line-height: 24px;
  color: #4b5b76;
  max-width: 475px;
}

.cdc-carousel__item-operate {
  margin-top: 16px;
}

.cdc-carousel__item-search {
  width: 480px;
  height: 40px;
  background: #f4f4f5;
  border-radius: 30px;
  padding: 2px 90px 2px 20px;
  box-sizing: border-box;
  position: relative;
}

.cdc-carousel__item-search .search-input {
  box-sizing: border-box;
  background: transparent;
  width: 100%;
  font-size: 14px;
  color: #181818;
  line-height: 36px;
  outline: none;
  border: none;
}

.cdc-carousel__item-search .search-btn {
  position: absolute;
  width: 81px;
  height: 36px;
  line-height: 34px;
  border-radius: 30px;
  top: 2px;
  right: 2px;
  min-width: unset;
}

.cdc-btn {
  height: 36px;
  min-width: 92px;
  padding: 0 16px;
  background-color: #0052d9;
  border: 1px solid transparent;
  box-sizing: border-box;
  line-height: 34px;
  font-size: 14px;
  color: #fff;
  box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
  cursor: pointer;
  text-align: center;
}

.layout-main .mod-selector {
  box-sizing: border-box;
  padding: 28px 0 1px;
  /* background: linear-gradient(0deg, #f5f7fa -55.92%, #fff 93.75%); */
  background: linear-gradient(0deg, #b9cdeb -55.92%, #fff 93.75%);
}

.mod-selector__inner {
}

.mod-selector__item {
  position: relative;
  max-height: 54px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 8px 0;
}

.mod-selector__item:last-child {
  margin-bottom: 27px;
}

.mod-selector__item-inner {
  display: flex;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 54px 0 10px;
  position: relative;
}

.mod-selector__item-label {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #181818;
  flex-shrink: 0;
  margin-right: 16px;
  padding-top: 8px;
}

.mod-selector__item-tags {
  flex: 1 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -2px -8px;
}

.mod-selector__item-tag {
  cursor: pointer;
  box-sizing: border-box;
  padding: 8px 20px;
  position: relative;
  font-size: 14px;
  line-height: 22px;
  color: #4b5b76;
  margin: 0 2px 8px;
}

.mod-selector__item-tag.is-selected {
  background: #fff;
  color: #0052d9;
}

.mod-selector__item-tag.is-selected:after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border: 1px solid #0052d9;
  border-radius: 2px;
}

.layout-main .cdc-tech-video__main {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 20px;
  box-sizing: border-box;
  /* padding: 0 10px; */
  min-height: calc(100vh - 320px - 530px - 140px);
}

.mod-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 36px auto 20px;
  font-size: 14px;
  line-height: 22px;
  color: #4b5b76;
}

.mod-filter__list {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
}

li {
  list-style: none;
}

.mod-filter__item {
  margin-right: 42px;
  cursor: pointer;
}

.mod-filter__item.is-selected,
.cdc-tech-video-page .cdc-tech-video__main .mod-filter__item:hover {
  color: #0052d9;
}

.mod-filter__total {
  flex-shrink: 1;
}

.mod-course {
  /* width: 1200px; */
  margin: 0 auto;
}

.mod-course .mod-course__list {
  min-height: 200px;
  /* overflow: hidden; */
  padding-top: 24px;

  display: flex;
  flex-wrap: wrap;
}

.mod-course .mod-course__list .item {
  cursor: pointer;
  float: left;
  margin: 0 20px 20px 0;
  border-radius: 8px;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
  line-height: 0;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
}

.mod-course .mod-course__list .item:nth-child(5n) {
  margin-right: 0;
}

.section {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 224px;
  height: 288px;
  border-radius: 8px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 0;
  overflow: hidden;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
}

.section .img {
  width: 100%;
  max-height: 162px;
  overflow: hidden;

  font-size: 20px;
  line-height: 162px;
  text-align: center;
  color: #999;
}

.section .con {
  position: relative;
  padding: 10px 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 126px;
  border-radius: 0 0 8px 8px;

  border-top: 1px dashed #e4e4e4;
}

.section .con .info {
  margin: 0;
  padding: 0;
  outline: none;

  height: 94px;
}

.section .con .info .title {
  max-height: 36px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFangSC;
  line-height: 18px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.section .con .info p {
  height: 12px;
  line-height: 12px;
  font-size: 12px;
  margin-top: 6px;
  color: #666;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section .con .info span {
  position: absolute;
  bottom: 12px;
  right: 14px;
  display: inline-block;
  font-size: 12px;
  min-width: 50px;
  height: 12px;
  line-height: 12px;
  color: #999;
}

.section .con .bottom {
  height: 20px;
  font-family: PingFangSC-Regular, PingFangSC;
}

.section .con .bottom .price_con {
  position: relative;
  text-align: left;
  top: -8px;
}

.section .con .bottom .price_con span {
  display: inline-block;
  color: #ff7a3e;
  font-size: 20px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
}

.section .con .bottom .price_con span.free {
  color: #00cc7e;
}
</style>
